import React, { useContext, useState, useEffect } from 'react';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import { AppContext, AuthContext } from 'Context';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearAllDummys } from 'store/store';
import axios from 'axios';
import { baseUrl } from 'Api';
import styles from './index.module.css';

const CheckoutElementsStripe = () => {
  const {
    screatId,
    stripeUiSelector,
    expressCheckout,
    switchingFunction,
    apiCALL,
  } = useContext(AppContext);
  const { getToken } = useContext(AuthContext);
  const stripe = useStripe();
  const navigate = useNavigate();
  const location = useLocation();
  const elements = useElements();
  const dispatch = useDispatch();
  const uploadPercentages = useSelector((state) => state.upload);
  const tokens = getToken();
  const [loading, setLoading] = useState(false);
  const [isPaymentReady, setIsPaymentReady] = useState(false);

  const clearAllDummy = () => {
    dispatch(clearAllDummys());
  };

  const handleManagerSwitch = async (obj) => {
    clearAllDummy();
    const result = await switchingFunction(obj);
    if (result?.success) {
      navigate('/dashboard');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!stripe || !elements) {
      setLoading(false);
      return;
    }

    let result;

    if (stripeUiSelector === 0) {
      // Free promo → SetupIntent
      result = await stripe.confirmSetup({
        elements,
        confirmParams: { return_url: `${window.location.origin}/access` },
        redirect: 'if_required',
      });
    } else {
      // Normal payment → PaymentIntent
      result = await stripe.confirmPayment({
        elements,
        confirmParams: { return_url: `${window.location.origin}/access` },
        redirect: 'if_required',
      });
    }

    console.log('Stripe Response:', result);

    if (result.error) {
      console.error('Payment/Setup failed:', result.error);
    } else {
      expressCheckout(screatId);
      if (location.pathname === '/pay-by-manger') {
        handleManagerSwitch(apiCALL?.data?.userDetails[0]);
      } else {
        navigate('/access');
      }
    }

    setLoading(false);
  };

  return (
    <form
      className={styles.paymentUi}
      style={{
        borderRadius: '18px',
        border: '1px solid rgba(15, 23, 42, 0.06)',
        boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
      onSubmit={handleSubmit}
    >
      <PaymentElement
        options={{
          layout: 'tabs', // Enables multiple payment method tabs
          paymentMethodOrder: ['card', 'google_pay', 'apple_pay'],
        }}
        onChange={(event) => {
          setIsPaymentReady(event.complete);
        }}
      />
      <button
        className={styles.paybutt}
        style={{ marginTop: 'auto' }}
        type="submit"
        disabled={loading || !stripe || !elements || !isPaymentReady}
      >
        {loading ? 'Processing...' : 'Pay Now'}
      </button>
    </form>
  );
};

export default CheckoutElementsStripe;
